// === State Types ===

import { CheckApiResponse } from '@api/domain';

export enum NotificationStatusName {
  NeedUpdateApp = 'needUpdateApp',
  WarnToUpdateApp = 'warnToUpdateApp',
  IsServerWorking = 'isServerWorking',
  IsInternetReachable = 'isInternetReachable',
  Validating = 'validating',
}

export interface NotificationState {
  [NotificationStatusName.NeedUpdateApp]: boolean;
  [NotificationStatusName.WarnToUpdateApp]: boolean;
  [NotificationStatusName.IsServerWorking]: boolean;
  [NotificationStatusName.IsInternetReachable]: boolean;
  [NotificationStatusName.Validating]: boolean;
  ipAddress: string | null;
  versions: CheckApiResponse;
}

// === Action Payload Types ===

export interface UpdateNotificationStatusPayload {
  name: NotificationStatusName;
  value: boolean;
}

export type PlatformVersions = Pick<
  CheckApiResponse,
  'minimumVersionAppAndroid' | 'minimumVersionAppIOS' | 'previousVersionAppAndroid' | 'previousVersionAppIOS'
>;

export interface CachedPlatformVersions extends PlatformVersions {
  expiresAt: number;
}
